function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1 = _core.version;

var $JSON = _core.JSON || (_core.JSON = { stringify: JSON.stringify });
var stringify$1 = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

var stringify = createCommonjsModule(function (module) {
module.exports = { "default": stringify$1, __esModule: true };
});

var _JSON$stringify = unwrapExports(stringify);

/**
 * sdk配置
 */
// const config = {};

// 当把script都过滤的时候，是不会执行下列代码的

/**
 * 运行环境
 */
var env = {
    isSnapshotMode: false, // 默认非快照模式
    isPreviewMode: false, // 是否是预览模式
    isFilterScript: false, // 默认script没有被过滤, 暂时没有地方会用到这个参数，但是后续可能会支持过滤script时的抓取
    position: undefined // 页面的位置, 位于左右哪个iframe
};

var DEBUG_SDK_TIP_PREFIX = '[byted-search-debug-sdk]: '; // sdk中console输出info前缀

var DEBUG_DOM_ID = 'SEARCH_DEBUG_DOM';
var DEBUG_INFO_ATTR = 'data-debug-info'; // 储存后端使用的info
var DEBUG_RAW_DATA_ATTR = 'data-debug-raw-data'; // 储存快照页面(非静态，会保留script标签)使用的raw data
var DEBUG_REQUEST_ID_ATTR = 'data-debug-request-id'; // 存储静态快照(静态，不会保留script标签)使用的request_id

/**
 * 通信方法, 将数据发送给平台
 */
function sendMessageToPlatform(data) {
    window.top.postMessage({
        type: 'search_debug_message'.toUpperCase(),
        payload: {
            data: data
        },
        pos: env.position
    }, '*');
}

var sendMessageHandler = {
    message: function message(messageData) {
        var dataList = messageData.dataList,
            request_id = messageData.request_id,
            raw_data = messageData.raw_data;
        // 判断页面中是否已经将信息存储到dom上

        var debugDom = document.getElementById(DEBUG_DOM_ID);
        // 若还未挂载并存储信息到dom上的话，则进行挂载和存储操作(这里只会挂载首屏的信息)
        if (!debugDom) {
            var newDom = document.createElement('div');
            newDom.id = DEBUG_DOM_ID;

            // 将信息挂载到dom指定attr/dataset上
            newDom.setAttribute(DEBUG_INFO_ATTR, _JSON$stringify({
                list: dataList
            }));
            newDom.setAttribute(DEBUG_RAW_DATA_ATTR, _JSON$stringify(raw_data || {}));
            newDom.setAttribute(DEBUG_REQUEST_ID_ATTR, request_id);

            // 将携带了信息的dom都插入到body最顶部
            var firstDom = document.body.firstChild;
            document.body.insertBefore(newDom, firstDom);
        }
        // 当没有被作为iframe内嵌的时候不执行直接跳出
        if (window.self === window.top) {
            return;
        }
        // 将相关信息发送给平台侧
        sendMessageToPlatform(messageData);
    }
};

/* 获取路径path */
function getSearch(queryString) {
    var search = location.search.substr(1),
        hashQuery = {};
    if (search) {
        var arr = search.split('&');
        for (var i = 0; i < arr.length; i++) {
            var t = arr[i].split('=');
            hashQuery[t[0]] = t[1];
        }
    }
    if (typeof queryString == 'string') {
        return hashQuery[queryString] && decodeURIComponent(hashQuery[queryString]);
    }
    return hashQuery;
}

/**
 * 发送事件给平台侧
 */
function sendMessage(messageType, messageData) {
    var handler = sendMessageHandler[messageType];
    if (handler) {
        handler(messageData);
    } else {
        // eslint-disable-next-line no-console
        console.log(DEBUG_SDK_TIP_PREFIX + 'sendMessage\u6CA1\u6709' + messageType + '\u76F8\u5173handler');
    }
}

var onMessageHandler = {
    highlight_items: [],
    scroll_to_item: [],
    debug_preview_message: []
};

/**
 * 从平台侧接受事件
 */
function onMessage(messageType, messageCb) {
    var handlers = onMessageHandler[messageType];
    var isAlreadyExistHandler = handlers.indexOf(messageCb) > -1;
    if (isAlreadyExistHandler || typeof messageCb !== 'function') {
        // eslint-disable-next-line no-console
        console.log(DEBUG_SDK_TIP_PREFIX + 'onMessage\u4F20\u9012\u91CD\u590D\u7684' + messageType + ' handler \u6216 \u672A\u4F20\u5165\u56DE\u8C03\u51FD\u6570');
    } else {
        handlers.push(messageCb);
    }
}

/**
 * 移除事件监听
 */
function offMessage(messageType, messageCb) {
    var handlers = onMessageHandler[messageType];
    var idx = handlers.indexOf(messageCb);
    var isNotExistHandler = idx === -1;
    if (isNotExistHandler || typeof messageCb !== 'function') {
        // eslint-disable-next-line no-console
        console.log(DEBUG_SDK_TIP_PREFIX + 'offMessage\u4F20\u9012\u7684' + messageType + ' handler\u4E0D\u5B58\u5728\u4E8Ehandlers list\u4E2D, \u4E0D\u9700\u8981\u79FB\u9664 \u6216 \u672A\u4F20\u5165\u56DE\u8C03\u51FD\u6570');
    } else {
        handlers.splice(idx, 1);
    }
}

/**
 * 是否是快照模式，快照模式不能通过接口获取数据，只能通过sdk方法获取数据
 * @return {boolean}
 */
function isSnapshotMode() {
    return env.isSnapshotMode;
}

/**
 * 是否是预览模式，预览模式需要通过监听方法，获取平台侧传入的json数据来做展现
 * @return {boolean}
 */
function isPreviewMode() {
    return env.isPreviewMode;
}

/**
 * 快照模式时，通过此方法获取数据
 * @return {Object} rawData
 */
function getSnapshotData() {
    var dom = document.querySelector('[' + DEBUG_RAW_DATA_ATTR + ']');
    if (!dom) {
        // eslint-disable-next-line no-console
        console.log(DEBUG_SDK_TIP_PREFIX + '\u6CA1\u6709\u83B7\u53D6\u5230' + DEBUG_RAW_DATA_ATTR + '\u76F8\u5173DOM');
        return {};
    }
    var attrData = dom.getAttribute(DEBUG_RAW_DATA_ATTR);
    var rawData = {};
    try {
        rawData = JSON.parse(attrData);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(DEBUG_SDK_TIP_PREFIX + '\u89E3\u6790' + DEBUG_RAW_DATA_ATTR + '\u4E0Araw data\u51FA\u9519: ' + e);
    }
    return rawData;
}

/**
 * 初始化环境函数
 */
function init() {
    // 判断是否是预览模式
    if (getSearch('search_debug_preview_mode')) {
        env.isPreviewMode = true;
    } else if (document.querySelector('[' + DEBUG_RAW_DATA_ATTR + ']')) {
        // 判断是否是被抓取的快照页面
        // const curUrl = location.href;
        // 快照统一保存在tos上，可以通过这种方法来判断是否是快照模式
        env.isSnapshotMode = true;
    }

    // 获取位置信息
    env.position = getSearch('search_debug_side_pos');

    // 监听message事件
    window.addEventListener('message', function (_ref) {
        var data = _ref.data,
            source = _ref.source,
            origin = _ref.origin;

        // if (source !== window.top || origin.indexOf('search.bytedance.net') === -1) {
        if (source !== window.top) {
            // 监听最上层的事件, 且只监听来自search.bytedance.net域名下的事件
            return;
        }
        var type = data.type,
            payload = data.payload;

        var handlers = onMessageHandler[type];
        if (handlers) {
            handlers.forEach(function (handler) {
                handler(payload);
            });
        }
    });
}

// 初始化环境
init();

var messageObj = {
    sendMessage: sendMessage,
    onMessage: onMessage,
    offMessage: offMessage,
    isSnapshotMode: isSnapshotMode,
    getSnapshotData: getSnapshotData,
    isPreviewMode: isPreviewMode
};

export { sendMessage, onMessage, offMessage, isSnapshotMode, isPreviewMode, getSnapshotData };
export default messageObj;
